var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Rect, Defs, ClipPath } from "react-native-svg";
var SvgFlagEn = function SvgFlagEn(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    fill: "none",
    viewBox: "0 0 20 14"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#flag-en_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#012169",
    d: "M0 0h20v14H0z"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: "#fff",
    strokeWidth: 3,
    d: "m0 0 20 14M20 0 0 14"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: "#C8102E",
    d: "m0 0 20 14M20 0 0 14"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 5h20v4H0z"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M8 0h4v14H8z"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#C8102E",
    d: "M0 5.8h20v2.4H0z"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#C8102E",
    d: "M8.8 0h2.4v14H8.8z"
  }), /*#__PURE__*/React.createElement(Rect, {
    width: 19.5,
    height: 13.5,
    x: 0.25,
    y: 0.25,
    stroke: "#000",
    strokeOpacity: 0.25,
    strokeWidth: 0.5,
    rx: 1.75
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "flag-en_svg__a"
  }, /*#__PURE__*/React.createElement(Rect, {
    width: 20,
    height: 14,
    fill: "#fff",
    rx: 2
  })))));
};
export default SvgFlagEn;